var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('form-container',{attrs:{"targetUrl":_vm.url,"schema":_vm.schema,"expressions":_vm.expressions,"daysSessions":_vm.daysSessions,"chargeStep":_vm.chargeStep,"gdprVoids":_vm.gdpr_voids,"debug":_vm.debug}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }